import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import loadingpic from '../assets/loading.gif'

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return(
    <div className="d-flex justify-content-center align-items-center h-100">
      <img src={loadingpic} alt="Loading" />
    </div> 
  )
  if (!user) return <Navigate to="/login" />;

  return <div>{children}</div>
}
